"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3955],{

/***/ 65395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ SliceRelatedProducts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@next/components/organisms/ProductList/index.ts + 6 modules
var ProductList = __webpack_require__(27453);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 4 modules
var regions = __webpack_require__(34465);
// EXTERNAL MODULE: ./src/@next/utils/maps.ts
var maps = __webpack_require__(61514);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRelatedProducts/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px 0 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 0 0;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 1em;\n    font-weight: lighter;\n    color: ",
        ";\n    letter-spacing: -0.5px;\n    padding: 40px 0 0;\n    ",
        "\n    ",
        "\n    * {\n      font: inherit;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 60px;\n    padding-top: 60px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 40px;\n    padding-top: 40px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 80px;\n  padding-top: 80px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



// import { pageTitle } from '@styles/utils';
var pageTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(props) {
        return props.theme.typography.h2FontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, theme.colors.baseFont, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));
});
var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject6(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5()));
var Title = globalStyles/* styled.div */.zo.div(_templateObject8(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7()), pageTitle);
var List = globalStyles/* styled.h2 */.zo.h2(_templateObject10(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRelatedProducts/SliceRelatedProducts.tsx











function SliceRelatedProducts(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    var locale = (0,router.useRouter)().locale;
    var productIds = fields.map(function(node) {
        return (0,core/* generateKey */.HI)("".concat(node.productid), "Product");
    });
    var data = (0,generatedHooks/* useProductListQuery */.te)({
        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            filter: {
                ids: productIds || []
            },
            first: 4
        }, (0,regions/* localeToSaleorQuery */.KK)(locale)), {
            sortBy: null
        })
    }).data;
    if (data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            className: "slice-item slice-related-products",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: primary.slicetitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* ProductList */.c, {
                        innerList: true,
                        products: (0,maps/* mapEdgesToItems */.I)(data.products)
                    })
                })
            ]
        });
    }
    return null;
}
SliceRelatedProducts.componentName = "relatedproducts";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRelatedProducts/index.tsx



/***/ }),

/***/ 44610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rv": function() { return /* binding */ paddingLeft; },
  "tj": function() { return /* binding */ pageTitle; },
  "C7": function() { return /* binding */ prismicRichText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/title-top.svg
var title_top = __webpack_require__(43157);
;// CONCATENATED MODULE: ./src/images/title-top-blue.svg
var title_top_blue_namespaceObject = __webpack_require__.p + "static/images/title-top-blue.svg";
// EXTERNAL MODULE: ./src/@next/globalStyles/media.ts
var media = __webpack_require__(59390);
;// CONCATENATED MODULE: ./src/@next/globalStyles/utils.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 25px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 64px;\n        left: -25px;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 35px;\n        left: -15px;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px 0 0;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 0 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 1em;\n    font-weight: lighter;\n    color: ",
        ";\n    letter-spacing: -0.5px;\n    padding: 40px 0 0;\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: -44px;\n      top: 0;\n      width: 92px;\n      height: 15px;\n      background: url(",
        ") no-repeat left top;\n      background-size: contain;\n      ",
        "\n      ",
        "\n    }\n    &.blue {\n      &:before {\n        background: url(",
        ") no-repeat left top;\n        background-size: contain;\n      }\n    }\n    ",
        "\n    ",
        "\n    * {\n      font: inherit;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 15px;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 12px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 110%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  h5,\n  h6 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 140%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    line-height: 180%;\n    margin-bottom: ",
        ";\n  }\n\n  a {\n    text-decoration: underline;\n    color: ",
        ";\n  }\n\n  b {\n    font-weight: 600;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n\n  & em {\n    color: ",
        ";\n  }\n\n  ul,\n  ol {\n    margin-bottom: ",
        ";\n\n    li {\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: 220%;\n      color: ",
        "; // #666f73;\n    }\n  }\n\n  ul {\n    li {\n      padding-left: 24px;\n      position: relative;\n\n      &:before {\n        content: '';\n        display: block;\n        background-color: ",
        ";\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        position: absolute;\n        left: 0;\n        top: 17px;\n\n        ",
        "\n        ",
        "\n      }\n    }\n  }\n\n  ol {\n    list-style: inside;\n    list-style-type: decimal;\n  }\n\n  &.text-center * {\n    text-align: center;\n  }\n\n  &.text-right * {\n    text-align: right;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var paddingLeft = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
    var theme = param.theme;
    return "".concat(theme.container.paddingLeft, "px");
}, media/* media.mediumScreen */.B.mediumScreen(_templateObject()), media/* media.smallScreen */.B.smallScreen(_templateObject1()));
var pageTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), function(props) {
        return props.theme.typography.h2FontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, theme.colors.baseFont, title_top, media/* media.largeScreen */.B.largeScreen(_templateObject3()), media/* media.smallScreen */.B.smallScreen(_templateObject4()), title_top_blue_namespaceObject, media/* media.largeScreen */.B.largeScreen(_templateObject5()), media/* media.smallScreen */.B.smallScreen(_templateObject6()));
});
var prismicRichText = (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.colors.blueLight;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.colors.red;
}, media/* media.largeScreen */.B.largeScreen(_templateObject9()), media/* media.smallScreen */.B.smallScreen(_templateObject10()));


/***/ }),

/***/ 61514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mapEdgesToItems; }
/* harmony export */ });
function mapEdgesToItems(data) {
    var ref;
    return (data === null || data === void 0 ? void 0 : (ref = data.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var node = param.node;
        return node;
    })) || [];
}


/***/ }),

/***/ 32243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PrismicNextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/helpers/isFilled.js
var isFilled = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildURL.ts
/**
 * Converts a camel case string to a param case string.
 *
 * @example
 *
 * ```ts
 * camelCaseToParamCase("fooBar");
 * // => 'foo-bar'
 * ```
 *
 * @param input - Camel case string to convert.
 *
 * @returns Param case version of `input`.
 */ var camelCaseToParamCase = function(input) {
    return input.replace(/[A-Z]/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
};
/**
 * Builds a URL to an Imgix image with Imgix URL API parameters.
 *
 * The given URL must be a full absolute URL containing the protocol and domain.
 *
 * URL parameters already applied to the image will be retained. To remove
 * existing parameters, set the parameter to `undefined` in the `params` argument.
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png", {
 * 	width: 400,
 * });
 * // => https://example.imgix.net/image.png?width=400
 * ```
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png?width=400", {
 * 	height: 300,
 * });
 * // => https://example.imgix.net/image.png?width=400&height=300
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters.
 *
 * @returns `url` with the given Imgix URL API parameters applied.
 *
 * @see Imgix URL API reference: https://docs.imgix.com/apis/rendering
 */ var buildURL = function(url, params) {
    var instance = new URL(url);
    Object.keys(params).forEach(function(camelCasedParamKey) {
        var paramKey = camelCaseToParamCase(camelCasedParamKey);
        var paramValue = params[camelCasedParamKey];
        if (paramValue === undefined) {
            instance.searchParams.delete(paramKey);
        } else if (Array.isArray(paramValue)) {
            instance.searchParams.set(paramKey, paramValue.join(","));
        } else {
            instance.searchParams.set(paramKey, "".concat(paramValue));
        }
    });
    // Ensure the `s` parameter is the last parameter, if it exists.
    // @see https://github.com/imgix/imgix-blueprint#securing-urls
    var s = instance.searchParams.get("s");
    if (s) {
        instance.searchParams.delete("s");
        instance.searchParams.append("s", s);
    }
    return instance.toString();
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildWidthSrcSet.ts




/**
 * Builds an `<img>` `srcset` attribute value for a given set of widths. It can
 * also optinally apply Imgix URL API parameters to the URLs.
 *
 * The `width` URL parameter will be applied for each `srcset` entry. If a
 * `width` or `w` parameter is provided to the `params` parameter, it will be ignored.
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * });
 * // => https://example.imgix.net/image.png?width=400 400w,
 * //    https://example.imgix.net/image.png?width=800 800w,
 * //    https://example.imgix.net/image.png?width=1600 1600w
 * ```
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * 	sat: -100,
 * });
 * // => https://example.imgix.net/image.png?width=400&sat=-100 400w,
 * //    https://example.imgix.net/image.png?width=800&sat=-100 800w,
 * //    https://example.imgix.net/image.png?width=1600&sat=-100 1600w
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters. The `widths` parameter
 *   defines the resulting `srcset` widths.
 *
 * @returns A `srcset` attribute value for `url` with the given Imgix URL API
 *   parameters applied.
 */ var buildWidthSrcSet = function(url, _param) {
    var widths = _param.widths, params = (0,_object_without_properties/* default */.Z)(_param, [
        "widths"
    ]);
    return widths.map(function(width) {
        return "".concat(buildURL(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
            w: undefined,
            width: width
        })), " ").concat(width, "w");
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/PrismicNextImage.tsx
/* eslint-disable */ 







var castInt = function(input) {
    if (typeof input === "number" || typeof input === "undefined") {
        return input;
    }
    var parsed = Number.parseInt(input, 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return parsed;
};
/**
 * Creates a `next/image` loader for Imgix, which Prismic uses, with an optional
 * collection of default Imgix parameters.
 *
 * @see To learn about `next/image` loaders: https://nextjs.org/docs/api-reference/next/image#loader
 * @see To learn about Imgix's URL API: https://docs.imgix.com/apis/rendering
 */ var imgixLoader = function(args) {
    var url = new URL(args.src);
    var params = {
        auto: url.searchParams.getAll("auto") || [
            "format", 
        ],
        fit: url.searchParams.get("fit") || "max",
        w: args.width,
        h: undefined
    };
    if (args.quality) {
        params.q = args.quality;
    }
    return buildURL(args.src, params);
};
/**
 * React component that renders an image from a Prismic Image field or one of
 * its thumbnails using `next/image`. It will automatically set the `alt`
 * attribute using the Image field's `alt` property.
 *
 * It uses an Imgix URL-based loader by default. A custom loader can be provided
 * with the `loader` prop. If you would like to use the Next.js Image
 * Optimization API instead, set `loader={undefined}`.
 *
 * @param props - Props for the component.
 *
 * @returns A responsive image component using `next/image` for the given Image
 *   field.
 * @see To learn more about `next/image`, see: https://nextjs.org/docs/api-reference/next/image
 */ var PrismicNextImage = function(_param) {
    var field = _param.field, _imgixParams = _param.imgixParams, imgixParams = _imgixParams === void 0 ? {} : _imgixParams, alt = _param.alt, fallbackAlt = _param.fallbackAlt, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "imgixParams",
        "alt",
        "fallbackAlt"
    ]);
    if (typeof alt === "string" && alt !== "") {
        console.warn('[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="".');
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
        console.warn('[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="".');
    }
    if (isFilled/* imageThumbnail */.S$(field)) {
        var src = buildURL(field.url, imgixParams);
        var url = new URL(src);
        var mediaUrl = new URL("https://images.renodoors.eu/");
        url.hostname = mediaUrl.hostname;
        var ar = field.dimensions.width / field.dimensions.height;
        var resolvedWidth = field.dimensions.width;
        var resolvedHeight = field.dimensions.height;
        if ("width" in restProps || "height" in restProps) {
            var castedWidth = castInt(restProps.width);
            var castedHeight = castInt(restProps.height);
            if (castedWidth) {
                resolvedWidth = castedWidth;
            } else if (castedHeight) {
                resolvedWidth = ar * castedHeight;
            }
            resolvedHeight = resolvedWidth / ar;
        }
        var mobileSrcSet = field["mobile"] ? buildWidthSrcSet(field["mobile"].url, {
            widths: [
                constants/* smallScreen */.xC,
                2 * constants/* smallScreen */.xC
            ]
        }) : null;
        var tabletSrcSet = field["tablet"] ? buildWidthSrcSet(field["tablet"].url, {
            widths: [
                constants/* mediumScreen */.M7,
                2 * constants/* mediumScreen */.M7
            ]
        }) : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            children: [
                mobileSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* smallScreen */.xC, "px)"),
                    srcSet: mobileSrcSet
                }),
                tabletSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* mediumScreen */.M7, "px)"),
                    srcSet: tabletSrcSet
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                    src: url.href,
                    width: resolvedWidth,
                    height: resolvedHeight,
                    alt: alt !== null && alt !== void 0 ? alt : field.alt || fallbackAlt,
                    loader: imgixLoader
                }, restProps))
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/index.ts



/***/ }),

/***/ 36811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/chevron_left.svg";

/***/ }),

/***/ 81111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/chevron_right.svg";

/***/ }),

/***/ 43157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/title-top.svg";

/***/ })

}]);